import { useTaxonomyStore } from '@modules/taxonomy/store/taxonomyStore';
import Fade from '@mui/material/Fade';
import { TransitionProps } from '@mui/material/transitions';
import { forwardRef, useState } from 'react';

const TRANSITION_DURATION = 700; // 700 milliseconds

export const CreateNewReasonModalTransitionComponent = forwardRef(
  function Transition(
    props: TransitionProps & {
      children: React.ReactElement<any, any>;
    },
    ref: React.Ref<unknown>,
  ) {
    const [transitionStyles, setTransitionStyles] = useState({});
    const isV3ModalMinimised = useTaxonomyStore(
      ({ createReasonV3State: { visual } }) => visual?.isModalMinimised,
    );

    const setTransition = () => {
      if (!isV3ModalMinimised) {
        return;
      }

      setTransitionStyles(() => {
        return {
          transform: `translate3d(-40%,50%,0) scale(0)`,
          transition: 'all ' + TRANSITION_DURATION + 'ms ease',
          transitionProperty: 'transform, opacity',
        };
      });
    };

    return (
      <Fade
        ref={ref}
        {...props}
        style={transitionStyles}
        timeout={{
          enter: 250,
          exit: isV3ModalMinimised ? TRANSITION_DURATION : 250,
        }}
        onExiting={setTransition}
      />
    );
  },
);
